import React, { FC } from 'react';
import { Dropdown as AntDropdown } from 'antd';
import { DropDownProps } from 'antd/lib/dropdown';

import { GlobalStyle } from './styled';

export const Dropdown: FC<DropDownProps> = props => (
  <>
    <GlobalStyle />
    <AntDropdown {...props} />
  </>
);
